import { URL, URL_APIARY } from '../constants/api'
import axios from 'axios'

const defaultParams = {
  'pl': 8,
  'p': 1,
  'isSector' : true,
  property_type_id: ''
}

var cancelToken = {
}

axios.interceptors.response.use(undefined, err => {
  //if (err.status === 500 && err.config) {
  if (err.response && err.response.status === 404 && err.config && err.config.url && err.config.url.match(/\/api\/properties\//)) {
    return {data: err}
  }
  if (err.config) {
    return new Promise(function(resolve, reject) {
      setTimeout(()=>resolve(axios(err.config)), 2000)
    })
  }
  throw err
})

const requestAxios = function(url, idCancelToken) {
  if (cancelToken[idCancelToken])
    cancelToken[idCancelToken].cancel()
  cancelToken[idCancelToken] = axios.CancelToken.source()
  return axios({
    url: url,
    cancelToken: cancelToken[idCancelToken].token,
  }).then(data=>data.data)
  .catch(error => {
    console.error(error)
  })
}

export default {
  fetchProperties(params,d) {
    var defaults = Object.assign({}, defaultParams, d)
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params) + '&page=' + defaults.p + '&pl=' + defaults.pl
    return requestAxios(ENDPOINT, 'fetchProperties')
  },
  fetchPropertieTypes(params) {
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key])
    var qs = Object.keys(params).map(function(key) {
        return [key, JSON.stringify(params[key])].map(encodeURIComponent).join('=')
      }).join('&')
    var ENDPOINT = URL + 'properties/property_types?' + qs
    return requestAxios(ENDPOINT, 'fetchPropertieTypes')
  },
	fetchOperationTypesBySection(section) {
    var ENDPOINT = URL + 'properties/operation_types?section=' + section
    return requestAxios(ENDPOINT, 'fetchOperationTypesBySection')
  },
  fetchOperationTypes(id) {
    var ENDPOINT = URL + 'properties/operation_types?sector_id=' + id
    return requestAxios(ENDPOINT, 'fetchOperationTypes')
  },
  fetchSectors() {
    var ENDPOINT = URL + 'sectors'
    return requestAxios(ENDPOINT, 'fetchSectors')
  },
  fetchSubsidiaryTypes() {
    var ENDPOINT = URL + 'properties/subsidiary_types'
    return requestAxios(ENDPOINT, 'fetchSubsidiaryTypes')
  },
  fetchRelatedProperties(id) {
    var ENDPOINT = URL + 'properties/related?id=' + id + '&pl=' + 12
    return requestAxios(ENDPOINT, 'fetchRelatedProperties')
  },
  fetchNotInProperties(id) {
    var arrayId = []
    arrayId.push(id)
    var params = {'not_in_neighborhood_id': arrayId, 'category_type_id': [6]}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params) + '&pl=' + 12
    return requestAxios(ENDPOINT, 'fetchNotInProperties')
  },
  fetchImportantProperties(id, pl) {
    var arrayId = []
    arrayId.push(id)
    var params = {'neighborhoodFront_id': arrayId}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params) + '&pl=' + pl
    return requestAxios(ENDPOINT, 'fetchImportantProperties')
  },
  fetchRelevantProperties(category_type_id='', subsidiary_type_id='', property_type_id='') {
    var params = {'is_featured': true}
    if (category_type_id!='')   params.category_type_id = parseInt(category_type_id)
    if (subsidiary_type_id!='') params.subsidiary_type_id = parseInt(subsidiary_type_id)
    if (property_type_id!='')   params.property_type_id = property_type_id
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params) +'&pl=' + 24
    return requestAxios(ENDPOINT, 'fetchRelevantProperties')
  },
  fetchPropertiesDetail(id) {
    var ENDPOINT = URL + 'properties/' + id
    return requestAxios(ENDPOINT, 'fetchPropertiesDetail')
  },
  loadResidentialsTypes(){
    var arrayIds = []
    arrayIds.push(3)
    arrayIds.push(500000000000031)
    var ENDPOINT = URL + 'properties/property_types?isSector=' + false + '&property_type_id=' + JSON.stringify(arrayIds)
    return requestAxios(ENDPOINT, 'loadResidentialsTypes')
  },
  fetchSiblings(id){
    var ENDPOINT = URL + 'properties/siblings/' + id
    return requestAxios(ENDPOINT, 'fetchSiblings')
  }
}



// WEBPACK FOOTER //
// ./src/api/properties.js